import DxDataGrid, { DxLoadPanel, DxColumn } from "devextreme-vue/data-grid";
import { DxSpeedDialAction, DxSelectBox } from 'devextreme-vue';

import { contactService } from '../../../services/contact.service';

import notify from 'devextreme/ui/notify'

export default {
  name: "bizcontact",
  data() {
    return {
      dataSourceConfig: [],
      bizContacts: [],
      bizContactCount: 0,
      noReadBizContactCount: 0,
    };
  },
  methods: {
    fetchBizContactData() {

      let self = this

      contactService.getPublicBizContacts(null)
        .then(
          success => {
            if (success.messageType == 1) {

              self.bizContactCount = 0
              self.noReadBizContactCount = 0

              self.bizContacts = success.content;

              for (var i = 0; i <= self.bizContacts.length - 1; i++) {
                self.bizContactCount++;

                if (self.bizContacts[i].openStatusId == 1) {
                  self.noReadBizContactCount++;
                }
              }
            } else {
              self.showMessage(success.message, 'error');
            }
          },
          error => {
            console.log(error)
          }
        );
    },
    onClickRowToShowBizContacDetail(e) {
      this.$router.push({ name: 'biz-contact-detail', params: { bizcontactid: e.data.bizContactId } })
    },
    onClickRefreshData() {
      this.fetchBizContactData();
    },
    showMessage(text, type) {
      notify({
        message: text,
        shading: true
      }, type, process.env.VUE_APP_BASE_MESSAGE_NOTIFY_SHOWTIME)
    },
  },
  created() {
    this.fetchBizContactData()
  },
  watch: {
    '$route': 'fetchBizContactData'
  },
  components: {
    DxDataGrid,
    DxLoadPanel,
    DxColumn,
    DxSpeedDialAction,
    DxSelectBox,
  }
};